import { AwsAccountV8DtoServiceItem } from '@/api-client/cloud/model';
import { AwsServiceType, AzureServiceType } from '@/config/views/platform/cloud/type/cloud.type';

const CLOUD = {
  AWS: 'aws',
  AZURE: 'azure',
} as const;

const CLOUD_LABEL = {
  aws: 'AWS',
  azure: 'Azure',
};

const addPrefixToServiceKeysAndValues = (
  services: Record<string, string>,
  prefix: string,
): Record<string, string> => {
  return Object.entries(services).reduce(
    (acc, [key, value]) => {
      const newKey = `${prefix.toUpperCase()} ${key}`;
      const newValue = `${CLOUD_LABEL[prefix]} ${value}`;
      acc[newKey] = newValue;
      return acc;
    },
    {} as Record<string, string>,
  );
};

const CLOUD_AWS_SERVICE_UNIFIED_LABEL = {
  COST_EXPLORER: 'Cost Explorer',
  DMS: 'Database Migration Service',
  DOCUMENTDB: 'DocumentDB',
  DYNAMODB: 'DynamoDB',
  EC2: 'EC2',
  // ECS: 'ECS',
  ELASTICACHE: 'ElastiCache(for Redis)',
  LAMBDA: 'Lambda',
  RDS: 'RDS(+Aurora)',
  REDSHIFT: 'Redshift',
  S3: 'S3',
} satisfies Partial<Record<AwsAccountV8DtoServiceItem, string>>;

const CLOUD_AWS_SERVICE_LABEL = {
  AURORA: 'Aurora',
  DMS_REPLINSTANCE: 'DMS Replication Instance',
  DMS_TASK: 'DMS Task',
  DOCUMENTDB: 'DocumentDB',
  DYNAMODB: 'DynamoDB',
  EC2: 'EC2',
  // ECS_CLUSTER: 'ECS Cluster',
  // ECS_SERVICE: 'ECS Service',
  ELASTICACHE_CLUSTER: 'ElastiCache Cluster',
  ELASTICACHE_SHARD: 'ElastiCache Shard',
  ELASTICACHE_NODE: 'ElastiCache Node',
  ELASTICACHE_SERVERLESS: 'ElastiCache Serverless',
  LAMBDA: 'Lambda',
  // LIGHTSAIL_DATABASE: 'Lightsail Database',
  // LIGHTSAIL_INSTANCE: 'Lightsail Instance',
  RDS: 'RDS',
  REDSHIFT: 'Redshift',
  S3: 'S3',
  // VPC: 'VPC',
} satisfies Partial<Record<AwsServiceType, string>>;

const CLOUD_AZURE_SERVICE_LABEL = {
  BLOB_STORAGE: 'Blob Storage',
  CACHE_FOR_REDIS: 'Cache for Redis',
  CACHE_FOR_REDIS_ENTERPRISE: 'Cache for Redis Enterprise',
  COSMOS_DB: 'Cosmos DB',
  DATABASE_FOR_MYSQL: 'Database for MySQL',
  DATABASE_FOR_POSTGRESQL: 'Database for PostgreSQL',
  FUNCTIONS: 'Functions',
  SQL_DATABASE: 'SQL Database',
  VIRTUAL_MACHINES: 'Virtual Machines',
} satisfies Partial<Record<AzureServiceType, string>>;

const CLOUD_ALL_SERVICE_LABEL = { ...CLOUD_AWS_SERVICE_LABEL, ...CLOUD_AZURE_SERVICE_LABEL };
const CLOUD_ALL_SERVICE_UNIFIED = {
  ...CLOUD_AWS_SERVICE_UNIFIED_LABEL,
  ...CLOUD_AZURE_SERVICE_LABEL,
};

// NOTE: 클라우드명 접두사 추가 버전
const PREFIX_AWS_SERVICE_LABEL = addPrefixToServiceKeysAndValues(
  CLOUD_AWS_SERVICE_LABEL,
  CLOUD.AWS,
);
const PREFIX_AZURE_SERVICE_LABEL = addPrefixToServiceKeysAndValues(
  CLOUD_AZURE_SERVICE_LABEL,
  CLOUD.AZURE,
);

const PREFIX_CLOD_ALL_SERVICE_LABEL = {
  ...PREFIX_AWS_SERVICE_LABEL,
  ...PREFIX_AZURE_SERVICE_LABEL,
};

export {
  CLOUD,
  CLOUD_LABEL,
  CLOUD_AWS_SERVICE_LABEL,
  CLOUD_AZURE_SERVICE_LABEL,
  CLOUD_ALL_SERVICE_LABEL,
  CLOUD_AWS_SERVICE_UNIFIED_LABEL,
  CLOUD_ALL_SERVICE_UNIFIED,
  PREFIX_AWS_SERVICE_LABEL,
  PREFIX_AZURE_SERVICE_LABEL,
  PREFIX_CLOD_ALL_SERVICE_LABEL,
};
